const PROPERTY_TYPE_MAP = {
  STRING: `string`,
  NUMBER: `number`,
  DATE: `datetime`,
  BOOLEAN: `boolean`,
  LIST: `list`,
};

const PROPERTY_SOURCE_MAP = {
  EVENTS: `properties`,
  PEOPLE: `user`,
};

const STRING_FILTER_OPERATOR_MAP = {
  CONTAINS: `in`,
  DOES_NOT_CONTAIN: `not in`,
  EQUALS: `==`,
  DOES_NOT_EQUAL: `!=`,
  SET: `set`,
  NOT_SET: `not set`,
};

const NUMBER_FILTER_OPERATOR_MAP = {
  BETWEEN: `><`,
  GREATER_THAN: `>`,
  LESS_THAN: `<`,
  EQUAL_TO: `==`,
};

const ABSOLUTE_DATE_FILTER_OPERATOR_MAP = {
  ON: `==`,
  BETWEEN: `><`,
};

const RELATIVE_DATE_FILTER_OPERATOR_MAP = {
  LESS_THAN: `<`,
  GREATER_THAN: `>`,
};

const TIME_UNIT_MAP = {
  DAY: `days`,
  WEEK: `weeks`,
  MONTH: `months`,
};

const BOOLEAN_FILTER_OPERATOR_MAP = {
  true: `true`,
  false: `false`,
};

const LIST_FILTER_OPERATOR_MAP = {
  CONTAINS: `in`,
};

/* eslint-disable camelcase */
export function propertyToSegFilter(property, {isTypecastable = true} = {}) {
  const segFilter = {
    dropdown_tab_index: 0,
    property: {
      name: property.name,
      source: PROPERTY_SOURCE_MAP[property.source],
      type: PROPERTY_TYPE_MAP[property.type],
    },
    type: PROPERTY_TYPE_MAP[property.typecast || property.type],
  };
  if (isTypecastable) {
    segFilter.selected_property_type = PROPERTY_TYPE_MAP[property.type];
  }
  return segFilter;
}
/* eslint-enable camelcase */

export function propertyFilterToSegFilter(propertyFilter, {isTypecastable = true} = {}) {
  let filter;
  if (propertyFilter.stringFilter) {
    const {operator, operands} = propertyFilter.stringFilter;
    let operand;
    if ([`EQUALS`, `DOES_NOT_EQUAL`].includes(operator)) {
      operand = operands;
    } else if ([`CONTAINS`, `DOES_NOT_CONTAIN`].includes(operator)) {
      operand = operands[0];
    } else {
      operand = ``;
    }
    filter = {
      operator: STRING_FILTER_OPERATOR_MAP[operator],
      operand,
    };
  } else if (propertyFilter.numberFilter) {
    const {operator, operand1, operand2} = propertyFilter.numberFilter;
    filter = {
      operator: NUMBER_FILTER_OPERATOR_MAP[operator],
      operand: operator === `BETWEEN` ? [operand1.toString(), operand2.toString()] : operand1.toString(),
    };
  } else if (propertyFilter.absoluteDateFilter) {
    const {operator, operand1, operand2} = propertyFilter.absoluteDateFilter;
    filter = {
      operator: ABSOLUTE_DATE_FILTER_OPERATOR_MAP[operator],
      operand: operator === `BETWEEN` ? [operand1, operand2] : operand1,
    };
  } else if (propertyFilter.relativeDateFilter) {
    const {operator, operand, timeUnit} = propertyFilter.relativeDateFilter;
    filter = {
      operator: RELATIVE_DATE_FILTER_OPERATOR_MAP[operator],
      operand,
      unit: TIME_UNIT_MAP[timeUnit],
    };
  } else if (propertyFilter.booleanFilter) {
    const {operand} = propertyFilter.booleanFilter;
    filter = {
      operand: BOOLEAN_FILTER_OPERATOR_MAP[operand],
    };
  } else if (propertyFilter.listFilter) {
    const {operator, operand} = propertyFilter.listFilter;
    filter = {
      operator: LIST_FILTER_OPERATOR_MAP[operator],
      operand,
    };
  } else {
    return;
  }
  return Object.assign(propertyToSegFilter(propertyFilter.property, {isTypecastable}), {filter});
}

export function propertyFiltersToSegFilters(propertyFilters, {isTypecastable = true} = {}) {
  return propertyFilters.map((filter) => propertyFilterToSegFilter(filter, {isTypecastable})).filter((x) => x);
}

export function propertyFiltersToCohorts(propertyFilters) {
  return propertyFilters
    .map((propertyFilter) => {
      if (propertyFilter.cohortFilter) {
        return {
          id: propertyFilter.cohortFilter.operand,
          name: propertyFilter.property.name,
        };
      }
    })
    .filter((x) => x);
}

export function getReportBaseUrl({projectId, workspaceId}) {
  const projectOrWorkspace = workspaceId ? `workspace/${workspaceId}` : `${projectId}`;
  return `/report/${projectOrWorkspace}`;
}
